import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class MaterialEntradaService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.url = '';
        this.url = SCAMP_API.accountApiV1;
    }
    getById(id) {
        return this.http.get(`${this.url}/materiais-entrada/${id}`, {
            headers: this.account.composeHeaders(),
        });
    }
    getAll() {
        return this.http.get(`${this.url}/materiais-entradas`, {
            headers: this.account.composeHeaders(),
        });
    }
    getMaterialEntradaPorPeriodo(parameters) {
        return this.http.get(`${this.url}/materiais-entrada/por-periodo/${parameters.dataInicial}/${parameters.dataFinal}`, {
            headers: this.account.composeHeaders(),
        });
    }
    exportarToExcel(parameters) {
        return this.http.get(`${this.url}/materiais-entrada/por-periodo/excel/${parameters.dataInicial}/${parameters.dataFinal}`, { headers: this.account.composeHeaders() });
    }
    getByPartNumeroDocumento(numeroDocumento) {
        return this.http.get(`${this.url}/materiais-entrada/by-part-numero-documento/${numeroDocumento}`, { headers: this.account.composeHeaders() });
    }
    save(model) {
        return this.http.post(`${this.url}/materiais-entrada`, model, { headers: this.account.composeHeaders() });
    }
    IsUniqueNumeroDocumento(numeroDocumento, id) {
        return this.http.post(`${this.url}/materiais-entrada/isunique-numero-documento`, { numeroDocumento: numeroDocumento, id: id }, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${this.url}/materiais-entrada/${id}`, { headers: this.account.composeHeaders() });
    }
}
MaterialEntradaService.ngInjectableDef = i0.defineInjectable({ factory: function MaterialEntradaService_Factory() { return new MaterialEntradaService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: MaterialEntradaService, providedIn: "root" });
